import { WEB3_FAUCET_ENABLED } from 'config'
import { atom } from 'jotai'

export enum FaucetType {
  Layer1 = 1,
  Layer2 = 2,
}

export const faucetTabs = [
  {
    key: FaucetType.Layer2,
    name: 'ZKEX Faucet',
  },
]
if (WEB3_FAUCET_ENABLED) {
  faucetTabs.push({
    key: FaucetType.Layer1,
    name: 'Web3 Faucet',
  })
}
export const faucetTypeAtom = atom<FaucetType>(faucetTabs[0].key)
